import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {SeparateXyzSockets} from "#material/nodes/converter/separate-xyz/definition"
import {separateXyzDefinition} from "#material/nodes/converter/separate-xyz/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeVec3} from "#material/three/three-utils"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import {cyclesVec3} from "#material/cycles/helpers"
import type {ThreeReturns} from "#material/sockets/three"
import type {SeparateXyzNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class SeparateXyz extends MaterialNode<SeparateXyzSockets> {
    public override get definition() {
        return separateXyzDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<SeparateXyzSockets>> => {
        const vector =
            (await evaluator.get(this.parameters.inputs.vector))?.toVec3() ??
            threeVec3({
                x: this.parameters.settings.x ?? 0,
                y: this.parameters.settings.y ?? 0,
                z: this.parameters.settings.z ?? 0,
            })
        return {
            x: vector.x,
            y: vector.y,
            z: vector.z,
        }
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<SeparateXyzSockets>> => {
        const separateXyz: SeparateXyzNode = {
            type: "separate_xyz",
            inputs: {vector: await evaluator.get(this.parameters.inputs.vector)},
            parameters: {vector: this.parameters.inputs.vector ? undefined : cyclesVec3(this.parameters.settings.vector)},
            resources: {},
        }

        return {x: [separateXyz, "x"], y: [separateXyz, "y"], z: [separateXyz, "z"]}
    }
}
